import { machineConfig } from "machine/config";
import { actions } from "./actions";
import { TResultContext, TResultState, TResultEvent } from "./types";
import { services } from "./services";

export const ResultMachine = machineConfig<
  TResultContext,
  TResultState,
  TResultEvent
>(
  {
    id: "result",
    initial: "ready",
    context: {
      params: {
        order_no: "",
        status: 1,
      },
    },
    states: {
      ready: {
        id: "ready",
        on: {
          UPDATE_ORDER_STATUS: {
            target: "fetching",
            actions: "setParams",
          },
        },
      },
      fetching: {
        invoke: [
          {
            src: "updateOrderStatus",
            onDone: {
              target: "success",
            },
            onError: {
              target: "error",
            },
          },
        ],
      },
      success: {
        id: "success",
      },
      error: {
        id: "error",
      },
    },
  },
  {
    actions: actions,
    services: services,
  }
);
